var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_664",
    "data-name": "Group 664",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.224,
    height: 17,
    viewBox: "0 0 15.224 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 15.224,
    height: 17,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M5.321,17a4.747,4.747,0,0,1-1.335-.65c-1-.571-2-1.153-3-1.731A1.84,1.84,0,0,1,0,12.916q0-5.5,0-11A1.861,1.861,0,0,1,1.565.019,1.319,1.319,0,0,1,1.813,0q4.205,0,8.41,0A1.847,1.847,0,0,1,12.03,1.77c.013.813.007,1.626,0,2.438A.623.623,0,1,1,10.785,4.2c0-.735,0-1.471,0-2.206a.646.646,0,0,0-.74-.741H3.032l-.008.027L4.05,1.87c.819.473,1.635.949,2.457,1.416a1.889,1.889,0,0,1,1.008,1.76q0,3.873,0,7.747c0,.255,0,.255.254.255h2.273c.51,0,.741-.231.741-.737,0-.63,0-1.261,0-1.891a.624.624,0,0,1,.617-.662.63.63,0,0,1,.632.667q0,1,0,1.991a1.877,1.877,0,0,1-1.891,1.9q-1.211.011-2.422,0c-.159,0-.212.046-.208.206a4.138,4.138,0,0,1-.042.992A1.853,1.853,0,0,1,6.062,16.97L5.951,17Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M185.7,111.527a.32.32,0,0,0-.177-.017h-4.147a.641.641,0,0,1-.681-.489.617.617,0,0,1,.492-.754,2.246,2.246,0,0,1,.347-.025l3.948,0a.3.3,0,0,0,.218-.042c-.193-.19-.382-.372-.567-.558a.625.625,0,0,1,.825-.94c.607.58,1.2,1.181,1.784,1.781a.592.592,0,0,1,.053.725.883.883,0,0,1-.124.155q-.819.823-1.641,1.643a.629.629,0,0,1-.684.171.614.614,0,0,1-.259-1c.163-.18.343-.345.513-.519.037-.038.09-.065.1-.127",
    transform: "translate(-172.668 -103.724)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.4e1c23824610702fffb46f380ffe7575.svg";
export { ForwardRef as ReactComponent };